import { createRouter, createWebHistory } from 'vue-router'
import HomeView from "../views/HomeView"
import UserView from "../views/UserView"
import ErrorView from "../views/ErrorView"

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/user',
    name: 'user',
    component: UserView
  },
  {
    path: '/aboutus',
    name: 'about',
    component: HomeView
  },
  {
    path: '/#getstart',
    name: 'started',
    component: HomeView
  },
  {
    path: '/#service',
    name: 'service',
    component: HomeView
  },
  {
    path: '/#contactus',
    name: 'contact',
    component: HomeView
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'error',
    component: ErrorView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to){
    if (to.hash) {
      return {
        el: to.hash,
        top: 50
      }
    }
  }
})

export default router
